import { Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import {
  ClientIPTreeCategory,
  ClientIPTreeNode,
} from '../../../../client/client-ip-journal/client-ip-list/types/ClientIPListTree'
import { TagEditorTreeData, TagEditorTreeNode } from '../tag-editor-tree-node'

/**
 * Service for transforming ClientIPTreeNode to TagEditorTreeNode
 */
@Injectable({
  providedIn: 'root',
})
export class TagEditorTransformService {
  constructor() {}

  /**
   * Transform ClientIPTreeNode[] to TagEditorTreeNode[]
   */
  transformClientIpToTagEditor(clientIpNodes: ClientIPTreeNode[]): TagEditorTreeNode[] {
    return clientIpNodes.map((node) => this.transformSingleNode(node))
  }

  /**
   * Transform single ClientIPTreeNode to TagEditorTreeNode
   */
  private transformSingleNode(node: ClientIPTreeNode): TagEditorTreeNode {
    const tagEditorData: TagEditorTreeData = {
      categoryId: node.data?.id || 0,
      categoryName: node.data?.type || ClientIPTreeCategory.PROGRAM_ENROLLMENT,
    }

    return {
      key: node.key || node.data?.id?.toString() || '',
      label: node.label || '',
      data: tagEditorData,
      icon: node.icon || 'pi pi-tag',
      children: node.children ? node.children.map((child) => this.transformSingleNode(child)) : undefined,
    }
  }

  /**
   * Transform Observable<ClientIPTreeNode[]> to Observable<TagEditorTreeNode[]>
   */
  transformObservable(clientIpNodes$: Observable<ClientIPTreeNode[]>): Observable<TagEditorTreeNode[]> {
    return clientIpNodes$.pipe(map((nodes) => this.transformClientIpToTagEditor(nodes)))
  }
}
